var map = {
	"./account.svg": "eluC",
	"./activity-white.svg": "9+hP",
	"./activity.svg": "5p87",
	"./arrow-left.svg": "tqch",
	"./bell-white.svg": "Jsz5",
	"./bell.svg": "aWB/",
	"./buy.svg": "BJ8h",
	"./community.svg": "HVL6",
	"./dashboard.svg": "sm9Y",
	"./forecast.svg": "9A88",
	"./help.svg": "ijvn",
	"./information.svg": "Yuu7",
	"./live-feed.svg": "Ozyv",
	"./notification.svg": "8TID",
	"./portfolio.svg": "CZdj",
	"./prediction.svg": "E+vL",
	"./rate.svg": "muIl",
	"./sell.svg": "YKaf",
	"./settings.svg": "6g1Y",
	"./support.svg": "jVvO",
	"./trading.svg": "dJjF",
	"./wallet.svg": "6xR6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 22